import { render, staticRenderFns } from "./PUserSelectDialog.vue?vue&type=template&id=a6c78ac8"
import script from "./PUserSelectDialog.vue?vue&type=script&lang=js"
export * from "./PUserSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports